import React from 'react';
import { useNavigate } from 'react-router-dom';
import { formatDistanceToNow } from 'date-fns';
import { GitBranch, Users, Share2, ChevronRight } from 'lucide-react';
import { toast } from 'sonner';

export const QuestionCard = ({ question }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/q/${question.question_id}`);
  };

  const handleShare = (e) => {
    e.stopPropagation();
    const url = `${window.location.origin}/q/${question.question_id}`;
    
    if (navigator.share) {
      navigator.share({
        title: question.title,
        text: question.description || 'Check out this mindmap on Clarities',
        url: url,
      }).catch(() => {});
    } else {
      navigator.clipboard.writeText(url);
      toast.success('Link copied to clipboard!');
    }
  };

  const timeAgo = formatDistanceToNow(new Date(question.created_at), { addSuffix: true });

  return (
    <div 
      className="question-card cursor-pointer group animate-fade-in"
      onClick={handleClick}
      data-testid={`question-card-${question.question_id}`}
    >
      <div className="flex items-start justify-between gap-4">
        <div className="flex-1 min-w-0">
          <h3 className="text-lg font-semibold text-slate-900 group-hover:text-orange-600 transition-colors line-clamp-2">
            {question.title}
          </h3>
          {question.description && (
            <p className="mt-2 text-sm text-slate-500 line-clamp-2">
              {question.description}
            </p>
          )}
        </div>
        <div className="flex items-center gap-2 flex-shrink-0">
          <button
            onClick={handleShare}
            className="w-8 h-8 rounded-full bg-slate-100 flex items-center justify-center text-slate-500 hover:bg-orange-100 hover:text-orange-500 transition-colors opacity-0 group-hover:opacity-100"
            title="Share"
            data-testid={`share-card-${question.question_id}`}
          >
            <Share2 className="w-4 h-4" />
          </button>
          <ChevronRight className="w-5 h-5 text-slate-400 group-hover:text-orange-500 transition-colors" />
        </div>
      </div>

      <div className="mt-4 flex items-center gap-4 text-sm text-slate-500">
        <div className="flex items-center gap-1.5">
          <GitBranch className="w-4 h-4" />
          <span>{question.node_count} nodes</span>
        </div>
        <div className="flex items-center gap-1.5">
          <Users className="w-4 h-4" />
          <span>{question.contributor_count} contributors</span>
        </div>
      </div>

      <div className="mt-4 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="w-6 h-6 rounded-full bg-slate-200 flex items-center justify-center text-xs font-medium text-slate-600">
            {question.author_name?.charAt(0).toUpperCase()}
          </div>
          <span className="text-sm text-slate-600">{question.author_name}</span>
        </div>
        <span className="text-xs text-slate-400">{timeAgo}</span>
      </div>
    </div>
  );
};
